import { Loader } from "@circle-react-uikit/Loader";
import { useBulkImportTrialPaywallSubscriptionFormContext } from "./BulkImportTrialPaywallSubscriptionFormProvider";
import { CouponForm } from "./CouponForm";
import { NotifyMemberForm } from "./NotifyMemberForm";
import { PaywallForm } from "./PaywallForm";
import { PaywallPriceForm } from "./PaywallPriceForm";
import { TrialDaysForm } from "./TrialDaysForm";

export const BulkImportTrialPaywallSubscriptionForm = () => {
  const { isPaywallLoading } =
    useBulkImportTrialPaywallSubscriptionFormContext();

  if (isPaywallLoading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col pb-6">
      <div className="flex flex-col gap-x-5 md:flex-row">
        <PaywallForm />
        <PaywallPriceForm />
      </div>
      <div className="flex flex-col gap-x-5 md:flex-row">
        <CouponForm />
        <TrialDaysForm />
      </div>
      <div className="flex flex-col gap-x-5 md:flex-row">
        <NotifyMemberForm />
      </div>
    </div>
  );
};
